import LegalLayout from "@/pages/LegalLayout";

export default function AydinlatmaMetni() {
  return (
    <LegalLayout title="Aydınlatma Metni">
      <p className="text-sm text-zinc-500">
        Son güncelleme: {new Date().toLocaleDateString("tr-TR")}
      </p>

      <h2>Veri Sorumlusu</h2>
      <p>
        6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında,
        <strong> Kolay Arşivim </strong> uygulaması ("Uygulama") aracılığıyla
        işlenen kişisel verilerinizin veri sorumlusu Uygulama sahibidir. İşbu
        aydınlatma metni; kişisel verilerin ne şekilde, hangi amaçla, hangi
        hukuki sebebe dayanılarak toplandığı, kimlere aktarılabileceği ve
        haklarınız hakkında bilgi vermek amacıyla hazırlanmıştır.
      </p>

      <h2>İşlenen Kişisel Veriler</h2>
      <ul>
        <li><strong>Kimlik ve iletişim:</strong> Ad soyad, e-posta adresi.</li>
        <li><strong>Kimlik doğrulama:</strong> Şifre (yalnızca bcrypt ile
          geri döndürülemez şekilde hash'lenmiş halde saklanır; ham şifre
          kaydedilmez).</li>
        <li><strong>İşlem verileri:</strong> Kullanıcı tarafından girilen
          ekspertiz kayıtları (şehir/ilçe/mahalle, ada/parsel, taşınmaz türü,
          alan/değer bilgileri, koordinatlar, notlar, ekspertiz tarihi).</li>
        <li><strong>Teknik veriler:</strong> IP adresi (kaba brute-force koruması
          için pencere içinde tutulur; kalıcı loglanmaz), oturum çerezi.</li>
      </ul>

      <h2>İşleme Amaçları</h2>
      <ul>
        <li>Hesap oluşturma, giriş ve oturum yönetimi</li>
        <li>Ekspertiz kayıtlarının size özel olarak sunulması</li>
        <li>Hizmetin güvenliğinin sağlanması (brute-force ve kötüye kullanım
          koruması)</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi</li>
      </ul>

      <h2>Hukuki Sebepler</h2>
      <p>
        Kişisel verileriniz KVKK Md. 5/2 (a-c-f) uyarınca (i) kanunlarda açıkça
        öngörülmesi, (ii) sözleşmenin kurulması veya ifası için gerekli olması ve
        (iii) meşru menfaat kapsamında işlenmektedir. Bunlar dışındaki kullanımlar
        için açık rızanız aranır.
      </p>

      <h2>Aktarım</h2>
      <p>
        Verileriniz üçüncü taraflara pazarlama amacıyla aktarılmaz. Yalnızca
        aşağıdaki teknik hizmet sağlayıcılara veri işleyen sıfatıyla aktarım
        yapılabilir:
      </p>
      <ul>
        <li><strong>Konum servisleri:</strong> Nominatim (OpenStreetMap
          topluluk servisi) — sadece adres/koordinat sorguları için, kişisel
          veri gönderilmez.</li>
        <li><strong>Türkiye idari veri servisi:</strong> turkiyeapi.dev —
          il/ilçe/mahalle listeleri için, kişisel veri gönderilmez.</li>
        <li><strong>Barındırma:</strong> Emergent platformu (Kubernetes)
          altyapısı.</li>
      </ul>

      <h2>Saklama Süresi</h2>
      <p>
        Verileriniz hesabınız aktif olduğu sürece saklanır. Hesabınızı sildiğinizde
        ("Ayarlar → Hesabımı Sil") tüm ekspertiz kayıtlarınız kalıcı olarak
        silinir. Yasal saklama yükümlülüğü doğuran durumlarda ilgili süre kadar
        anonim/pseudonim formda tutulabilir.
      </p>

      <h2>Haklarınız (KVKK Md. 11)</h2>
      <p>Aşağıdaki haklara sahipsiniz:</p>
      <ul>
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmişse buna ilişkin bilgi talep etme</li>
        <li>İşleme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Eksik/yanlış işlenmiş verilerinizin düzeltilmesini isteme
          (uygulama içinden "Düzenle" ile yapılabilir)</li>
        <li>Silinmesini/yok edilmesini isteme
          (uygulama içinden "Hesabımı Sil" ile yapılabilir)</li>
        <li>İşlenen verilerinizin bir kopyasını alma
          (uygulama içinden "Verilerimi İndir" ile JSON olarak indirilebilir)</li>
        <li>KVKK'ya aykırı işleme sebebiyle zararınızın giderilmesini talep etme</li>
      </ul>

      <h2>İletişim</h2>
      <p>
        Yukarıdaki haklarınızı kullanmak veya soru/şikayetleriniz için
        uygulama sahibi ile Uygulama üzerinden iletişim kurabilirsiniz.
      </p>
    </LegalLayout>
  );
}
